/**
 * Images et contenu enrichi par métier pour les landing pages.
 * Chaque métier a : hero image, alt, problèmes spécifiques, FAQ adaptée.
 */

export const METIER_IMAGES = {
  plombier: {
    heroImage: "https://images.unsplash.com/photo-1676210134188-4c05dd172f89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxwbHVtYmVyJTIwd29ya2luZyUyMHBpcGVzJTIwcmVwYWlyJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4OTIyNTg3OHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Plombier professionnel en intervention sur un chantier",
    emoji: "🔧",
    specialites: ["Dépannage urgent", "Sanitaire", "Chauffage", "Débouchage"],
    problemesMetier: [
      "Urgences 24/7 impossibles à gérer seul",
      "Appels manqués pendant les interventions sous l'évier",
      "Devis de dépannage non relancés car trop occupé",
      "Concurrence féroce sur Google Maps",
    ],
  },
  electricien: {
    heroImage: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjB3aXJpbmclMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzg5MjI1ODc4fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Électricien installant un tableau électrique",
    emoji: "⚡",
    specialites: ["Installation", "Dépannage", "Rénovation", "Domotique"],
    problemesMetier: [
      "Chantiers qui s'enchaînent sans temps pour prospecter",
      "Appels de dépannage urgent perdus sur chantier",
      "Devis d'installation non relancés après visite",
      "Difficulté à se démarquer des grandes enseignes",
    ],
  },
  serrurier: {
    heroImage: "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxsb2Nrc21pdGglMjB3b3JraW5nJTIwZG9vciUyMGxvY2slMjByZXBhaXJ8ZW58MHx8fHwxNzg5MjI1ODc4fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Serrurier en intervention sur une porte",
    emoji: "🔐",
    specialites: ["Ouverture de porte", "Blindage", "Cylindres", "Urgences"],
    problemesMetier: [
      "Urgences nocturnes impossibles à capter sans IA",
      "Les clients choisissent le premier serrurier qui répond",
      "Forte concurrence et arnaques qui nuisent à la profession",
      "Pas de temps pour le marketing entre les interventions",
    ],
  },
  chauffagiste: {
    heroImage: "https://images.unsplash.com/photo-1732660513320-a6b489f3fece?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxoZWF0aW5nJTIwdGVjaG5pY2lhbiUyMGJvaWxlciUyMHJlcGFpcnxlbnwwfHx8fDE3ODkyMjU4Nzh8MA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Chauffagiste en maintenance sur une chaudière",
    emoji: "🔥",
    specialites: ["Chaudières", "Pompes à chaleur", "Entretien", "Installation"],
    problemesMetier: [
      "Saison d'hiver surchargée, été trop calme",
      "Appels d'urgence chauffage manqués le week-end",
      "Devis de remplacement chaudière jamais relancés",
      "Transition PAC qui demande de nouveaux clients",
    ],
  },
  peintre: {
    heroImage: "https://images.unsplash.com/photo-1688372199140-cade7ae820fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwYWludGVyJTIwd2FsbCUyMHBhaW50aW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg5MjI1ODg2fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Peintre professionnel appliquant de la peinture au rouleau",
    emoji: "🎨",
    specialites: ["Intérieur", "Extérieur", "Décoration", "Rénovation"],
    problemesMetier: [
      "Projets saisonniers avec des creux d'activité",
      "Clients qui comparent 5 devis et ne rappellent jamais",
      "Pas de visibilité en ligne face aux grandes entreprises",
      "Relances manuelles chronophages entre deux chantiers",
    ],
  },
  menuisier: {
    heroImage: "https://images.unsplash.com/photo-1659930087003-2d64e33181f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxjYXJwZW50ZXIlMjB3b29kd29ya2luZyUyMHdvcmtzaG9wJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4OTIyNTg4Nnww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Menuisier travaillant le bois en atelier",
    emoji: "🪚",
    specialites: ["Cuisines", "Agencement", "Sur mesure", "Restauration"],
    problemesMetier: [
      "Projets longs qui laissent peu de temps au commercial",
      "Devis sur mesure complexes rarement relancés",
      "Bouche-à-oreille insuffisant pour remplir le planning",
      "Difficulté à montrer son savoir-faire en ligne",
    ],
  },
  paysagiste: {
    heroImage: "https://images.unsplash.com/photo-1597201278257-3687be27d954?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsYW5kc2NhcGVyJTIwZ2FyZGVuJTIwZGVzaWduJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc4OTIyNTg5M3ww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Jardin paysager professionnel avec massifs fleuris",
    emoji: "🌿",
    specialites: ["Création", "Entretien", "Terrasses", "Arrosage"],
    problemesMetier: [
      "Forte saisonnalité avec des mois creux en hiver",
      "Clients qui demandent des devis et disparaissent",
      "Concurrence des auto-entrepreneurs sur les petits jardins",
      "Pas de vitrine web pour montrer ses réalisations",
    ],
  },
  renovation: {
    heroImage: "https://images.unsplash.com/photo-1674649207083-281c2517ab49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxob21lJTIwcmVub3ZhdGlvbiUyMGFwYXJ0bWVudCUyMHJlbW9kZWwlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODkyMjU5MDB8MA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Chantier de rénovation intérieure d'un appartement",
    emoji: "🏗️",
    specialites: ["Salle de bains", "Cuisine", "Appartement", "Énergétique"],
    problemesMetier: [
      "Projets complexes avec de multiples corps de métier",
      "Devis de rénovation lourds rarement relancés",
      "Clients qui hésitent longtemps avant de se décider",
      "Gestion administrative chronophage entre les chantiers",
    ],
  },
  carreleur: {
    heroImage: "https://images.unsplash.com/photo-1463082459669-fd1ca1692fea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx0aWxpbmclMjBmbG9vciUyMHdvcmtlciUyMGNyYWZ0c21hbiUyMGhhbmRzfGVufDB8fHx8MTc4OTIyNTkwN3ww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Carreleur posant du carrelage au sol",
    emoji: "🧱",
    specialites: ["Salle de bains", "Cuisine", "Terrasse", "Mosaïque"],
    problemesMetier: [
      "Chantiers physiques qui empêchent de répondre au téléphone",
      "Devis de salle de bains comparés avec 3 autres artisans",
      "Planning mal rempli entre deux gros chantiers",
      "Pas de présence web pour montrer ses poses",
    ],
  },
  facadier: {
    heroImage: "https://images.unsplash.com/photo-1616320999187-3c004dad4f0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxmYWNhZGUlMjByZW5vdmF0aW9uJTIwc2NhZmZvbGRpbmclMjBidWlsZGluZyUyMGV4dGVyaW9yfGVufDB8fHx8MTc4OTIyNTg5M3ww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Échafaudage sur façade en cours de rénovation",
    emoji: "🏢",
    specialites: ["Crépis", "Isolation", "Ravalement", "Peinture extérieure"],
    problemesMetier: [
      "Gros chantiers qui mobilisent l'équipe pendant des semaines",
      "Appels de prospection manqués sur l'échafaudage",
      "Devis d'isolation extérieure jamais relancés",
      "Saisonnalité forte liée à la météo",
    ],
  },
  couvreur: {
    heroImage: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxyb29mZXIlMjB3b3JraW5nJTIwcm9vZnRvcCUyMHJlcGFpciUyMHRpbGVzfGVufDB8fHx8MTc4OTIyNTg4Nnww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Couvreurs travaillant sur un toit",
    emoji: "🏠",
    specialites: ["Réfection", "Étanchéité", "Entretien", "Tuiles"],
    problemesMetier: [
      "Urgences après tempête impossibles à gérer seul",
      "Appels manqués quand on est perché sur le toit",
      "Devis d'étanchéité oubliés dans la boîte mail",
      "Difficulté à capter les demandes d'entretien régulier",
    ],
  },
  ferblantier: {
    heroImage: "https://images.unsplash.com/photo-1738162837340-da3e7a323a09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxzaGVldCUyMG1ldGFsJTIwd29ya2VyJTIwcm9vZmluZyUyMHppbmMlMjBndXR0ZXJ8ZW58MHx8fHwxNzg5MjI1OTA3fDA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Ferblantier travaillant la tôle en atelier",
    emoji: "🔩",
    specialites: ["Gouttières", "Zinguerie", "Étanchéité", "Couverture métallique"],
    problemesMetier: [
      "Métier de niche avec peu de visibilité en ligne",
      "Appels manqués en atelier ou sur le toit",
      "Devis techniques rarement relancés",
      "Clients qui ne savent pas qu'ils ont besoin d'un ferblantier",
    ],
  },
  vitrier: {
    heroImage: "https://images.unsplash.com/photo-1512479373983-bd28a541041b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHx3aW5kb3clMjBnbGFzcyUyMGluc3RhbGxhdGlvbiUyMHdvcmtlcnxlbnwwfHx8fDE3ODkyMjU5MDB8MA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Vitrier professionnel installant des vitres",
    emoji: "🪟",
    specialites: ["Remplacement", "Double vitrage", "Vitrines", "Urgences"],
    problemesMetier: [
      "Urgences bris de glace qui arrivent à toute heure",
      "Impossibilité de répondre avec du verre dans les mains",
      "Devis de double vitrage comparés sans relance",
      "Peu de présence digitale dans ce métier",
    ],
  },
  macon: {
    heroImage: "https://images.unsplash.com/photo-1704005445445-2747074be8ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxicmlja2xheWVyJTIwY2VtZW50JTIwd2FsbCUyMGNvbnN0cnVjdGlvbiUyMHdvcmtlcnxlbnwwfHx8fDE3ODkyMjU4OTN8MA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Maçon posant des briques avec du ciment",
    emoji: "🧱",
    specialites: ["Construction", "Rénovation", "Agrandissement", "Béton"],
    problemesMetier: [
      "Gros chantiers qui empêchent toute prospection",
      "Appels de nouveaux clients perdus sur le chantier",
      "Devis de construction rarement suivis",
      "Concurrence des grandes entreprises de BTP",
    ],
  },
  platrier: {
    heroImage: "https://images.unsplash.com/photo-1482731215275-a1f151646268?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwbGFzdGVyZXIlMjBkcnl3YWxsJTIwY2VpbGluZyUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3ODkyMjU5MDB8MA&ixlib=rb-4.1.0&q=85",
    heroAlt: "Plâtrier travaillant sur un faux plafond",
    emoji: "🏗️",
    specialites: ["Cloisons", "Faux plafonds", "Enduits", "Isolation"],
    problemesMetier: [
      "Travaux salissants qui empêchent de toucher le téléphone",
      "Planning creux entre deux chantiers de plâtrerie",
      "Devis d'aménagement intérieur non relancés",
      "Métier souvent sollicité en sous-traitance uniquement",
    ],
  },
  photovoltaique: {
    heroImage: "https://images.unsplash.com/photo-1660330589243-4c640d878052?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMHJvb2YlMjBpbnN0YWxsYXRpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc4OTIyNTkwMHww&ixlib=rb-4.1.0&q=85",
    heroAlt: "Techniciens installant des panneaux solaires sur un toit",
    emoji: "☀️",
    specialites: ["Panneaux solaires", "Batteries", "Bornes de recharge", "Audit énergétique"],
    problemesMetier: [
      "Demande croissante mais difficile à capter en ligne",
      "Visites techniques longues qui empêchent de prospecter",
      "Devis d'installation solaire comparés sans retour",
      "Besoin d'éduquer le client sur le ROI photovoltaïque",
    ],
  },
};

export default METIER_IMAGES;
